import React from 'react'
import { Tooltip } from '@baseV2'
import { getLeadRolesText } from '@pages/Admin/Lead/leadRoles'
import { Border, CalendarToday, CardBox, CardHeaderRow, CardMeta, CardTitle } from '../styles'
import { showDateFormat } from '@utils'
import StatusBadge from './StatusBadge'
import calendarIcon from '@assets/icons/calendar.svg'
import locationIcon from '@assets/icons/location.svg'
import mobileIcon from '@assets/icons/mobile.svg'
import { categoryText, getSourceLabel } from './Card'

const CardTwo = ({ activeCard }) => {
	return (
		<CardBox>
			<CardHeaderRow>
				{activeCard?.raw?.source ? (
					<StatusBadge status={activeCard?.raw?.source?.replace(/\s+/g, '_')} label={getSourceLabel(activeCard?.raw?.source)} />
				) : (
					'-'
				)}
				<CalendarToday>
					<img src={calendarIcon} alt='calendarIcon' />
					{activeCard?.created_at ? showDateFormat(new Date(activeCard?.created_at)) : '-'}
				</CalendarToday>
			</CardHeaderRow>
			<CardTitle>{activeCard?.organisation_name || '-'}</CardTitle>
			<CardHeaderRow>
				<Tooltip content={getLeadRolesText(activeCard?.roles) || undefined} block>
					<CardMeta>{getLeadRolesText(activeCard?.roles) || 'Role: -'}</CardMeta>
				</Tooltip>
				<CardMeta>{activeCard?.pan || '-'}</CardMeta>
			</CardHeaderRow>
			<Border />
			{!!activeCard?.category_items?.length && (
				<>
					<CardMeta>{categoryText(activeCard)}</CardMeta>
					<Border />
				</>
			)}
			<CardHeaderRow>
				<CalendarToday>
					<img src={locationIcon} alt='locationIcon' />
					{activeCard?.location || '-'}
				</CalendarToday>
				<CalendarToday>
					<img src={mobileIcon} alt='mobileIcon' />
					{activeCard?.raw?.user_details?.mobile_number || '-'}
				</CalendarToday>
			</CardHeaderRow>
		</CardBox>
	)
}

export default CardTwo
